export const CHANGE_PASSWORD_RESULT = {
    SUCCESS: 1,
    OLD_PASSWORD_INVALID: 2,
    NEW_PASSWORD_INVALID: 3,
}